module.exports = __webpack_public_path__ + "static/media/gen_abs_ex0.c243d0e1.JPG";